var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { updateCartItemEditor, updatePhotoUploadProcess, uploadPhotos } from '../store/actions';
import { replaceCartItem } from '../../Cart/store/actions';
var mapStateToProps = function (state) { return ({
    cartItemEditor: state.cartItemEditor,
}); };
var mapDispatchToProps = {
    uploadPhotos: uploadPhotos,
    replaceCartItem: replaceCartItem,
    updateCartItemEditor: updateCartItemEditor,
    updatePhotoUploadProcess: updatePhotoUploadProcess,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var PhotoUploader = /** @class */ (function (_super) {
    __extends(PhotoUploader, _super);
    function PhotoUploader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formElement = null;
        _this.inputElement = null;
        return _this;
    }
    PhotoUploader.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { onClick: function () { return _this.handleClick(); } },
            React.createElement("form", { method: "POST", ref: function (element) {
                    if (_this.props.setFormElementRef) {
                        _this.props.setFormElementRef(element);
                    }
                    _this.formElement = element;
                }, onSubmit: this.handleFormSubmit.bind(this) },
                React.createElement("input", { ref: function (element) {
                        _this.inputElement = element;
                        if (_this.props.setInputElementRef) {
                            _this.props.setInputElementRef(element);
                        }
                    }, accept: "image/jpeg", type: "file", name: "images", onChange: function (e) { return _this.handleFileChange(e); }, style: { visibility: 'hidden', position: 'absolute' }, multiple: true })),
            this.props.children));
    };
    PhotoUploader.prototype.handleClick = function () {
        if (!this.inputElement) {
            return;
        }
        this.inputElement.click();
    };
    PhotoUploader.prototype.handleFormSubmit = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        if (!this.inputElement) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.handleFiles(this.inputElement.files)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PhotoUploader.prototype.handleFileChange = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleFiles(e.target.files)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PhotoUploader.prototype.handleFiles = function (files) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var formData, response, item, failed, uploaded, photosLength, selectedPhoto;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!files) {
                            return [2 /*return*/];
                        }
                        formData = new FormData();
                        formData.append('cart_item_id', String(this.props.cartItemId));
                        Array.from(files).forEach(function (file, i) { return formData.append('images[' + i + ']', file); });
                        return [4 /*yield*/, this.props.uploadPhotos(formData, function (progressEvent) {
                                _this.props.updatePhotoUploadProcess({
                                    total: progressEvent.total,
                                    loaded: progressEvent.loaded,
                                });
                                if (_this.props.handleUploadProgress) {
                                    _this.props.handleUploadProgress(progressEvent);
                                }
                            })];
                    case 1:
                        response = _b.sent();
                        if (!response) {
                            // TODO: error handling
                            return [2 /*return*/];
                        }
                        item = response.item, failed = response.failed, uploaded = response.uploaded;
                        photosLength = this.props.cartItemEditor.photos.items.length;
                        selectedPhoto = ((_a = item.photos) === null || _a === void 0 ? void 0 : _a.length) ? item.photos[photosLength ? item.photos.length - 1 : 0] : null;
                        this.props.replaceCartItem(item);
                        this.props.updateCartItemEditor({
                            productItems: __spreadArray([], item.product.items),
                            photos: __spreadArray([], item.photos),
                            selectedPhoto: selectedPhoto,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return PhotoUploader;
}(React.Component));
export default connector(withRouter(PhotoUploader));
